import { GumshoeUser } from '@/models';
import { HttpService } from '@/services/http.service';
import { UserService } from '@/services/user.service';
import Cookies from 'js-cookie';
import VueRouter from 'vue-router';
import { Store } from 'vuex';

import * as ACTIONS from '../store/mutation-types';

export class AuthService {
  constructor(
    public store: Store<any>,
    public userService: UserService,
    public router: VueRouter,
    public http: HttpService
  ) {}
  public get currentUser(): GumshoeUser {
    return this.userService.currentUser();
  }
  public get isLoggedIn() {
    return this.currentUser.isAuthenticated;
  }
  public isInRole(rolesToCheck: string[]): boolean {
    if (this.currentUser && this.currentUser.roles && rolesToCheck) {
      return this.currentUser.roles.some(r => rolesToCheck.includes(r));
    }

    return false;
  }

  public redirectToLogin() {
    this.router.push(`/login?${this.uuidv4()}`);
  }
  public redirectToAccessDenied() {
    this.router.push(`/access-denied?${this.uuidv4()}`);
  }
  public login(username: string, password: string) {
    const request = new FormData();
    request.set('username', username);
    request.set('password', password);

    return this.http.post(`/slenderAuth/v1/Auth/Login`, request).then(resp => {
      if (resp.data.data.status === 200) {
        this.userService.setCurrentUser(resp.data, Cookies.get(ACTIONS.COOKIE));
      }

      return resp.data;
    });
  }
  public logout() {
    const request = new FormData();
    return this.http
      .post(`/slenderAuth/v1/Auth/Logout`, {})
      .then(resp => {
        console.log('logout success');

        return resp;
      })
      .catch(err => {
        return err;
      })
      .finally(() => this.userService.clear());
  }
  private uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      const r = (Math.random() * 16) | 0,
        v = c == 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }
}
